import React, {useState} from 'react';
import {Accordion, AccordionDetails, AccordionSummary} from '@material-ui/core';
import {ExpandMore} from '@material-ui/icons';

type SubAccordionInfo = {
  children: React.ReactNode;
  title: string | React.ReactNode;
};
const SubAccordion = ({children, title}: SubAccordionInfo) => {
  const [subAccordion, setSubAccordion] = useState(true);

  return (
    <Accordion
      className="prod-deploy-details__subaccordion"
      expanded={subAccordion}
      elevation={0}
      onChange={() => setSubAccordion(curr => !curr)}
    >
      <AccordionSummary
        className="prod-deploy-details__subaccordion__title-container"
        expandIcon={<ExpandMore />}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails className="prod-deploy-details__subaccordion__details">
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default SubAccordion;
